import ViewProjectDetails from "./ViewProjectDetails";
export { ProjectStats, Stat } from "./components";
export default ViewProjectDetails;